import React from "react";
import { Box, Typography, Paper, Checkbox, FormControlLabel, Button } from "@mui/material";

/**
 * RefundSelector
 *
 * A component that allows users to select one or more items from a previous transaction
 * for refund. Renders a checkbox list of stornierbare items and a submit button.
 *
 * Props:
 * - items: Array of item objects from original transaction
 * - cancelledQuantities: object of sku => cancelled count
 * - onSelect: function (sku, selected:boolean) => void
 * - onRefund: () => void
 * - disabled: whether interaction is disabled
 */

export default function RefundSelector({ items, cancelledQuantities, onSelect, onRefund, disabled }) {
  const selectableItems = items.filter(item => {
    const qty = item?.item?.quantity || 0;
    const alreadyCancelled = cancelledQuantities?.[item.item.number] || 0;
    return qty - alreadyCancelled > 0;
  });

  return (
    <Paper variant="outlined" sx={{ p: 2,mb: 2 }}>
      <Typography variant="h6" gutterBottom>Artikel für Storno auswählen</Typography>

      {selectableItems.length === 0 ? (
        <Typography variant="body2" color="text.secondary">Keine Artikel verfügbar für Storno.</Typography>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {selectableItems.map((item, i) => {
            const sku = item.item.number;
            const remaining = item.item.quantity - (cancelledQuantities?.[sku] || 0);
            const label = `${item.text} – ${remaining} verfügbar`;

            return (
              <FormControlLabel
                key={sku}
                control={
                  <Checkbox
                    onChange={(e) => onSelect(i, e.target.checked)}
                    disabled={disabled || remaining <= 0}
                  />
                }
                label={label}
              />
            );
          })}

          <Button
            variant="contained"
            color="error"
            onClick={onRefund}
            disabled={disabled || selectableItems.length === 0}
          >
            Positionen aktualisieren
          </Button>
        </Box>
      )}
    </Paper>
  );
}